module.exports = __webpack_public_path__ + "static/lounge2-0b1edab6884af99badefc36219994244.jpg";